// Lightweight, deterministic device fingerprint for the Game (email/password auth).
// SHA-256 over stable browser signals → hex hash. No network calls.

function getCanvasSignature(): string {
  try {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) return "no-canvas";
    canvas.width = 220;
    canvas.height = 30;
    ctx.textBaseline = "top";
    ctx.font = "14px 'Arial'";
    ctx.fillStyle = "#069";
    ctx.fillText("FLOW Game device check 🎮", 2, 5);
    ctx.fillStyle = "rgba(255, 99, 0, 0.7)";
    ctx.fillRect(100, 5, 80, 20);
    return canvas.toDataURL().slice(-80);
  } catch {
    return "canvas-err";
  }
}

function getWebGLSignature(): string {
  try {
    const canvas = document.createElement("canvas");
    const gl = (canvas.getContext("webgl") || canvas.getContext("experimental-webgl")) as WebGLRenderingContext | null;
    if (!gl) return "no-webgl";
    const dbg = gl.getExtension("WEBGL_debug_renderer_info");
    if (!dbg) return "no-dbg";
    const vendor = gl.getParameter(dbg.UNMASKED_VENDOR_WEBGL);
    const renderer = gl.getParameter(dbg.UNMASKED_RENDERER_WEBGL);
    return `${vendor}|${renderer}`;
  } catch {
    return "webgl-err";
  }
}

async function sha256Hex(input: string): Promise<string> {
  const enc = new TextEncoder().encode(input);
  const buf = await crypto.subtle.digest("SHA-256", enc);
  return Array.from(new Uint8Array(buf))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

export async function computeGameDeviceHash(): Promise<string> {
  const parts: string[] = [
    navigator.userAgent || "",
    navigator.platform || "",
    navigator.language || "",
    String(navigator.hardwareConcurrency || 0),
    String((navigator as any).deviceMemory || 0),
    `${screen.width}x${screen.height}x${screen.colorDepth}`,
    Intl.DateTimeFormat().resolvedOptions().timeZone || "",
    getCanvasSignature(),
    getWebGLSignature(),
  ];
  return sha256Hex(parts.join("||"));
}
